import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfTokenFromURI, createHeaders, fetchJsonQuery } from "@mne-core/api";

import CustomersURI from "./CustomersURIBuilder";

export interface IDomain {
  id: number;
  name: string;
}

export interface IFetchAvailableDomainsParams {
  offset?: number;
  limit?: number;
}

export interface IFetchAvailableDomainsOpts {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
  sessionKey?: string;
}

export const createRequest = (queryParams: IFetchAvailableDomainsParams, opts: IFetchAvailableDomainsOpts): Request => {
  const { apiUrl, apikey, sessionKey, ...restOpts } = opts;
  const uri = new CustomersURI().setApiUrl(apiUrl).setSegment(["domain"]).setQuery(queryParams).build();

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    Accept: "application/json",
    "Argus-CSRF-Token": !apikey ? createCsrfTokenFromURI(sessionKey, uri) : null,
    "Content-type": "application/json",
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };
  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function fetchAvailableDomains(
  queryParams: IFetchAvailableDomainsParams,
  opts: IFetchAvailableDomainsOpts,
): Promise<JsonQuery<IResultstash<Array<IDomain>>>> {
  return await fetchJsonQuery<IResultstash<Array<IDomain>>>(createRequest(queryParams, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}
export default fetchAvailableDomains;
